<template>
	<div>
		<router-view />
		<Toaster position="top-center" />
	</div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { Toaster } from 'vue-sonner'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()

onMounted(() => {
	if (authStore.isLoggedIn && !authStore.user) {
		authStore.fetchUser()
	}
})
</script>
